import styled from 'styled-components/macro';

const Panel = styled.section<{ narrowTopPadding?: boolean; padding?: "none" | "compact" | "normal" }>`
    background-color: var(--color-surface);
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132);
    border-radius: 2px;

    ${({ narrowTopPadding }) => narrowTopPadding && `
        margin-top: 0.8rem;
    `}

${({ padding }) => padding === "none" && `
          padding: 0;
  `}

${({ padding }) => padding === "compact" && `
          padding: 1rem 2rem;
  `}

  ${({ padding }) => padding === "normal" && `
          padding: 2rem 3rem;
  `}
`;

export default Panel;
